var _path, _path2, _circle, _circle2, _path3, _path4, _rect, _path5, _path6, _g, _rect2, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportsStub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 201,
    viewBox: "0 0 219 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4185 117C47.816 117 45.5101 118.678 44.7095 121.154L39.5366 137.154C38.2837 141.029 41.1731 145 45.2456 145H157.754C161.827 145 164.716 141.029 163.463 137.154L158.29 121.154C157.49 118.678 155.184 117 152.581 117H50.4185ZM63 128C63 129.657 61.6569 131 60 131C58.3431 131 57 129.657 57 128C57 126.343 58.3431 125 60 125C61.6569 125 63 126.343 63 128ZM53 136C53 137.657 51.6569 139 50 139C48.3431 139 47 137.657 47 136C47 134.343 48.3431 133 50 133C51.6569 133 53 134.343 53 136ZM153 139C154.657 139 156 137.657 156 136C156 134.343 154.657 133 153 133C151.343 133 150 134.343 150 136C150 137.657 151.343 139 153 139ZM146 128C146 129.657 144.657 131 143 131C141.343 131 140 129.657 140 128C140 126.343 141.343 125 143 125C144.657 125 146 126.343 146 128Z",
    fill: "white",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 52C21 45.3726 26.3726 40 33 40H170C176.627 40 182 45.3726 182 52V129C182 135.627 176.627 141 170 141H165.506C165.872 139.594 165.859 138.061 165.367 136.539L160.194 120.539C159.126 117.237 156.052 115 152.582 115H50.419C46.9489 115 43.8745 117.237 42.807 120.539L37.6341 136.539C37.1419 138.061 37.1292 139.594 37.4948 141H33C26.3726 141 21 135.627 21 129V52ZM163.464 137.154C163.892 138.479 163.836 139.815 163.414 141H163.414C163.836 139.815 163.892 138.479 163.463 137.154L158.29 121.154C157.632 119.117 155.954 117.619 153.93 117.153C155.954 117.619 157.632 119.116 158.291 121.154L163.464 137.154ZM157.698 81.5068C157.698 91.0368 149.972 98.7624 140.442 98.7624C130.912 98.7624 123.187 91.0368 123.187 81.5068C123.187 71.9768 130.912 64.2512 140.442 64.2512C149.972 64.2512 157.698 71.9768 157.698 81.5068ZM62.5585 108.09C77.2399 108.09 89.1415 96.1882 89.1415 81.5068C89.1415 66.8254 77.2399 54.9238 62.5585 54.9238C47.8772 54.9238 35.9756 66.8254 35.9756 81.5068C35.9756 96.1882 47.8772 108.09 62.5585 108.09Z",
    fill: "white",
    fillOpacity: 0.08
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 77,
    r: 6,
    fill: "white",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 84,
    r: 6,
    fill: "white",
    fillOpacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50845 67.6868L3.19521 66.1783L0.178317 68.8048L1.49155 70.3132L4.50845 67.6868ZM40 111.5L38.4916 112.813L39.0894 113.5H40V111.5ZM112.5 74L114.377 73.3099L112.519 68.2545L110.627 73.2978L112.5 74ZM165 102L165.297 103.978L166.179 103.845L166.67 103.1L165 102ZM219 20L198.356 30.3527L217.644 43.0542L219 20ZM125 108L123.123 108.69L123.685 110.22L125.297 109.978L125 108ZM105 94L104.069 95.7698L106.076 96.8265L106.873 94.7022L105 94ZM95.5 89L96.4315 87.2302L94.8603 86.4032L93.853 87.8654L95.5 89ZM80 111.5V113.5H81.0509L81.647 112.635L80 111.5ZM1.49155 70.3132L38.4916 112.813L41.5084 110.187L4.50845 67.6868L1.49155 70.3132ZM166.67 103.1L210.771 36.1331L207.43 33.9331L163.33 100.9L166.67 103.1ZM110.623 74.6901L123.123 108.69L126.877 107.31L114.377 73.3099L110.623 74.6901ZM125.297 109.978L165.297 103.978L164.703 100.022L124.703 106.022L125.297 109.978ZM106.873 94.7022L114.373 74.7022L110.627 73.2978L103.127 93.2978L106.873 94.7022ZM94.5685 90.7698L104.069 95.7698L105.931 92.2302L96.4315 87.2302L94.5685 90.7698ZM40 113.5H80V109.5H40V113.5ZM81.647 112.635L97.147 90.1346L93.853 87.8654L78.353 110.365L81.647 112.635Z",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 149H156V192C156 194.209 154.209 196 152 196H51C48.7909 196 47 194.209 47 192V149Z",
    fill: "white",
    fillOpacity: 0.08
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 165,
    width: 65,
    height: 4,
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 163.5L61.5 170.5L58 167",
    stroke: "white",
    strokeOpacity: 0.05,
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_343_2153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 149,
    width: 109,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 149H156V159C156 161.209 154.209 163 152 163H51C48.7909 163 47 161.209 47 159V149Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_343_2153)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 149,
    width: 65,
    height: 4,
    fill: "#D9D9D9",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 147.5L61.5 154.5L58 151",
    stroke: "white",
    strokeOpacity: 0.05,
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 181,
    width: 65,
    height: 4,
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 179.5L61.5 186.5L58 183",
    stroke: "white",
    strokeOpacity: 0.05,
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsStub);
export default __webpack_public_path__ + "static/media/reports_stub.db03fb855ba567d18d0b81caac013907.svg";
export { ForwardRef as ReactComponent };